import React from "react";

export const ShieldSpinLoading = () => {
  const svgString = `<svg width="100%" height="100%"
 viewBox="0 0 150 150" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <style>
    #path-f {
      fill: none;
      stroke: #eaebee;
      stroke-width: 10;
      stroke-dasharray: 100 220;
      animation: dash 40s infinite linear forwards;
    }
    #path-b {
      fill: none;
      stroke: #0080ff;
      stroke-width: 8;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    @keyframes dash {
      to {
        stroke-dashoffset: 12000;
      }
    }
  </style>
  <title>Loading</title>
  <g id="单独" transform="translate(25.000000, 16.000000)" fill-rule="nonzero"  stroke-width="2" >
    <path d="M50,0 L0,30 C0,31 0,32 0,33 C0,69 20,100 50,116 C79,100 100,69 100,33 C100,32 99,31 99,30 L50,0 Z" id="path-b"/>
    <path d="M50,0 L0,30 C0,31 0,32 0,33 C0,69 20,100 50,116 C79,100 100,69 100,33 C100,32 99,31 99,30 L50,0 Z" id="path-f"/>
  </g>
</svg>`;

  return <div dangerouslySetInnerHTML={{ __html: svgString }} />;
};
